
import * as React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { timestampToDateTimeStringShort, timestampToWeekDay } from 'src/share/utils/utils';
import { ChartDaysCustomTooltip } from '../CustomTooltip/CustomTooltip';

export interface IMetricsContent {
    name: string;
    count: number;
}

export interface IDatesChartState { };

export interface IDatesChartProps {
    data: IMetricsContent[];
    dataKey: string;
    weekDay?: boolean;
    height?: any;
    strokePrimary?: boolean;
}

export class DatesChart extends React.PureComponent<IDatesChartProps, IDatesChartState> {
    constructor(props: IDatesChartProps) {
        super(props);
    }

    public getStartIndex() {
        const startIndex = this.props.data.length - 40;
        return this.props.data && startIndex > 0 ? startIndex : 0;
    }

    public render() {
        const { data, dataKey, strokePrimary, weekDay, height } = this.props;
        const tickFormatter = weekDay ? timestampToWeekDay : timestampToDateTimeStringShort
        return (
            <>
                {data.length === 0 && <p>No Data to Show</p>}
                {data.length > 0 && <ResponsiveContainer width={'95%'} height={height || 310}>
                    <AreaChart height={400} data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" tickFormatter={tickFormatter} />
                        <YAxis />
                        <Tooltip content={<ChartDaysCustomTooltip {...this.props} dataKey={dataKey} />} />
                        {data.length > 0 && <Area type='monotone' dataKey={'count'} stroke={strokePrimary ? '#2ABCCA' : '#E2BC2F'} fill={strokePrimary ? '#2ABCCA' : '#E2BC2F'} />}
                        {data.length === 0 && <Area type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
                    </AreaChart>
                </ResponsiveContainer>}
            </>

        )
    }
}
export default DatesChart;
